import { render, staticRenderFns } from "./virtualalert.vue?vue&type=template&id=7c32c640"
import script from "./virtualalert.vue?vue&type=script&lang=js"
export * from "./virtualalert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports